import axios from "axios";
import { HEADER_TOKEN } from "../config";

export const fileUpload = async (file, product_name) => {
  let result = null;
  const formData = new FormData();
  formData.append("myfile", file, file.name);
  formData.append("product_name", product_name);

  await axios
    .post(process.env.REACT_APP_API_URL + "/" + process.env.REACT_APP_SCHEDULER_API_VERSION + "/upload", formData, HEADER_TOKEN)
    .then((response) => {
      if (response.data.success == 1) {
        result = response.data.result;
      }
    })
    .then();
  return result;
};
